import clsx from 'clsx';

import { DatePicker } from '@atom/mui';

import classes from './workTemplateTaskDetail.module.css';

const TaskCompletedDate = () => {
  return (
    <div className={clsx(classes.timeRowItem, classes.input)}>
      <div className={classes.label}>Completed Date</div>
      <div className={classes.timePickerContainer}>
        <DatePicker value={null} onChange={() => {}} disabled />
      </div>
    </div>
  );
};

export default TaskCompletedDate;
